import { useInputState } from './useInputState';

const validations = [
  {
    validate: (value) => value && value.trim && !!value.trim(),
    errorMessage: 'cityRequiredError'
  },
  {
    validate: (value) => value && value.length <= 30,
    errorMessage: 'invalidCityLength'
  }
];

export function useCityInputState(options) {
  return useInputState({
    initialValue: '',
    validations,
    ...(options || {})
  });
}
